export default __webpack_public_path__ + "static/p2-80d1310cca62f832025e4d784f4fde3d.png";